module.exports = __webpack_public_path__ + "img/height_armhole.88eed063.png";